"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

require("./style.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var sizes = {
  xs: 8,
  sm: 16,
  md: 24,
  lg: 32
};

function SharedmailboxesGreyOutlined(_ref) {
  var className = _ref.className,
      inheritFontColor = _ref.inheritFontColor,
      inheritFontSize = _ref.inheritFontSize,
      size = _ref.size,
      width = _ref.width,
      height = _ref.height,
      disabled = _ref.disabled,
      onClick = _ref.onClick,
      muted = _ref.muted,
      clickable = _ref.clickable,
      children = _ref.children,
      props = _objectWithoutProperties(_ref, ["className", "inheritFontColor", "inheritFontSize", "size", "width", "height", "disabled", "onClick", "muted", "clickable", "children"]);

  var classes = ['orion-icons-svg-base'];

  if (inheritFontColor) {
    classes.push('orion-icons-svg-current-clr');
  }

  if (muted) {
    classes.push('orion-icons-svg-muted');
  }

  if (!disabled && (clickable || typeof onClick === 'function')) {
    classes.push('orion-icons-svg-clickable');
  }

  if (disabled) {
    classes.push('orion-icons-svg-disabled');
  }

  classes.push(className);
  var finalWidth = width || sizes[size];
  var finalHeight = height || sizes[size];

  if (inheritFontSize) {
    finalWidth = finalHeight = '1em';
  }

  var finalClass = classes.filter(Boolean).join(' ');
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: finalWidth,
    height: finalHeight,
    fill: "none",
    viewBox: "0 0 16 16",
    color: "currentColor",
    className: finalClass,
    onClick: !disabled ? onClick : null
  }, props), /*#__PURE__*/React.createElement("g", {
    fill: "#6C757D",
    clipPath: "url(#prefix__sharedmailboxes-grey-outlined__clip0_14934_7444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.93 1.203c.314 0 .62.094.88.27a1.6 1.6 0 01.584.72 1.623 1.623 0 01-.343 1.748 1.566 1.566 0 01-1.726.348 1.589 1.589 0 01-.711-.59 1.618 1.618 0 01.197-2.026c.297-.301.7-.47 1.12-.47zM6.93 0c-.548 0-1.084.165-1.54.473a2.8 2.8 0 00-1.02 1.26 2.84 2.84 0 00.6 3.059c.388.392.882.66 1.42.768a2.74 2.74 0 001.602-.16 2.78 2.78 0 001.244-1.033A2.832 2.832 0 008.89.822 2.755 2.755 0 006.931 0zM15.957 10.065a.626.626 0 00-.325-.329.572.572 0 00-.218-.044H8.68a.572.572 0 00-.218.044.626.626 0 00-.324.33.592.592 0 00-.044.22v5.113c0 .16.063.312.174.425a.59.59 0 00.42.176h6.733a.59.59 0 00.42-.176.605.605 0 00.174-.425v-5.113a.592.592 0 00-.06-.22zm-1.98.802l-1.937 1.965-1.933-1.957 3.87-.008zm-4.71 3.93v-3.06l2.353 2.383a.59.59 0 00.84 0l2.352-2.382v3.06H9.267z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.188 13.233V11.63c0-2.213 1.49-4.01 3.319-4.01h4.848c.47.01.932.13 1.35.35.418.218.78.53 1.061.913h1.406A4.452 4.452 0 0011.6 7.116a4.377 4.377 0 00-2.245-.7H4.507C2.027 6.416 0 8.762 0 11.629v2.005c-.012.2.054.395.184.545.13.15.313.243.51.257h6.593v-1.203H1.188zM10.273 4.046c-.18.5-.468.954-.843 1.327.09.006.182.006.273 0a2.452 2.452 0 001.613-.794c.42-.461.653-1.065.653-1.692s-.233-1.23-.653-1.691A2.452 2.452 0 009.703.4h-.119c.354.396.615.867.764 1.38.198.116.36.285.471.487a1.297 1.297 0 01-.044 1.315 1.273 1.273 0 01-.502.455v.008zM15.509 8.89a4 4 0 00-1.364-1.67 3.929 3.929 0 00-2.022-.708 5.774 5.774 0 011.83 2.142c.063.072.123.149.178.228h1.275l.103.008z"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "prefix__sharedmailboxes-grey-outlined__clip0_14934_7444"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0H16V16H0z"
  }))));
}

SharedmailboxesGreyOutlined.propTypes = {
  size: _propTypes["default"].string,
  width: _propTypes["default"].number,
  height: _propTypes["default"].number,
  className: _propTypes["default"].string,
  inheritFontColor: _propTypes["default"].bool,
  inheritFontSize: _propTypes["default"].bool,
  disabled: _propTypes["default"].bool,
  onClick: _propTypes["default"].func,
  clickable: _propTypes["default"].bool,
  muted: _propTypes["default"].bool
};
SharedmailboxesGreyOutlined.defaultProps = {
  size: 'sm',
  className: '',
  inheritFontColor: false,
  inheritFontSize: false,
  disabled: false,
  onClick: null,
  clickable: false,
  muted: true
};
var _default = SharedmailboxesGreyOutlined;
exports["default"] = _default;